import React from "react";
import "../css/css_layouts/PopupMessage.css";

const PopupMessage = ({ message, onClose }) => {
  return (
    <div className="popup-message-overlay">
      <div className="popup-message-box">
        <p>{message}</p>
        <button onClick={onClose}>OK</button>
      </div>
    </div>
  );
};

export default PopupMessage;